import { render, staticRenderFns } from "./ShareResponse.vue?vue&type=template&id=21a82880"
import script from "./ShareResponse.vue?vue&type=script&lang=js"
export * from "./ShareResponse.vue?vue&type=script&lang=js"
import style0 from "./ShareResponse.vue?vue&type=style&index=0&id=21a82880&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports